// extracted by mini-css-extract-plugin
export default {"wrap":"DataTable_wrap__ppmUF","table":"DataTable_table__8sMLY","empty":"DataTable_empty__Qypxs","sticky":"DataTable_sticky__KCOuJ","hoverable":"DataTable_hoverable__dA9-u"};